import React from "react";
import Checkbox from "../../../../../common/components/shared/checkbox/checkbox";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {storesContext} from "../../../../../common/stores/stores";
import i18n from "../../../../../i18n/i18n";
import {IOrderStore} from "../../../../stores/orderStore";
import DropDown from "../../../../../common/components/shared/dropDown/dropDown";
import {DropDownUtils} from "../../../../../helpers/dropDownUtils";
import {PackingService} from "../../../../../dictionaries/services/packingService";
import {PackingModel} from "../../../../../dictionaries/models/packing";
import {observer} from "mobx-react";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";

interface CargoSectionState {
    packing: PackingModel[];
    packingResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class CargoSection extends React.Component <any, CargoSectionState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            packing: [],
            packingResponse: undefined
        };
    }

    async componentDidMount() {
        await this.getPacking();
    }

    render() {
        const orderStore = this.context.orderStore as IOrderStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.order.details.cargo.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.order.details.cargo.properties.cargoDesc")}
                            validatedValue={orderStore.cargoDesc}
                            testId="cargo-desc"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.cargo.properties.weight")}
                            validatedValue={orderStore.weight}
                            testId="weight"
                            unit="kg"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.cargo.properties.length")}
                            validatedValue={orderStore.length}
                            testId="length"
                            unit="m"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.cargo.properties.width")}
                            validatedValue={orderStore.width}
                            testId="width"
                            unit="m"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.order.details.cargo.properties.height")}
                            validatedValue={orderStore.height}
                            testId="height"
                            unit="m"
                            offAutocomplete
                        />
                        {orderStore.displayCargoProperties && (
                            <>
                                <TextInput
                                    label={i18n.t("transportation.order.details.cargo.properties.packingQuantity")}
                                    validatedValue={orderStore.packingQuantity}
                                    testId="packing-quantity"
                                    offAutocomplete
                                />
                                <TextInput
                                    label={i18n.t("transportation.order.details.cargo.properties.cbm")}
                                    validatedValue={orderStore.cbm}
                                    testId="cbm"
                                    offAutocomplete
                                />
                                <DropDown
                                    className="element"
                                    label={i18n.t("transportation.order.details.cargo.properties.packing")}
                                    items={this.packingToDropdown()}
                                    validatedValue={orderStore.packingName}
                                    testId="packing"
                                    withEmptyValue
                                    isLoader={this.state.packing.length < 0}
                                    error={!Api.isSuccess(this.state.packingResponse) ? i18n.t("errorMessages.packingErrorSuffix") : ""}
                                    reloadFunc={() => this.getPacking()}
                                    isNoRequired
                                />
                                <TextInput
                                    label={i18n.t("transportation.order.details.cargo.properties.remarks")}
                                    validatedValue={orderStore.remarks}
                                    testId="remarks"
                                    offAutocomplete
                                />
                            </>
                        )}
                        {orderStore.displayWagonRegNo &&  (
                            <TextInput
                                label={i18n.t("transportation.order.details.cargo.properties.wagonRegNo")}
                                validatedValue={orderStore.wagonRegNo}
                                testId="wagon-reg-no"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displaySupplierWagonRegNo &&  (
                            <TextInput
                                label={i18n.t("transportation.order.details.cargo.properties.supplierWagonRegNo")}
                                validatedValue={orderStore.supplierWagonRegNo}
                                testId="supplier-wagon-reg-no"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displayRecipientWagonRegNo && (
                            <TextInput
                                label={i18n.t("transportation.order.details.cargo.properties.recipientWagonRegNo")}
                                validatedValue={orderStore.recipientWagonRegNo}
                                testId="recipient-wagon-reg-no"
                                offAutocomplete
                            />
                        )}
                        {orderStore.displaySecuringDeclaration && (
                            <Checkbox
                                label={i18n.t("transportation.order.details.cargo.properties.securingDeclaration")}
                                validatedValue={orderStore.securingDeclaration}
                                testId="securing-declaration"
                            />
                        )}
                    </Row>
                </div>
            </div>
        );
    }

    private packingToDropdown() {
        return DropDownUtils.listToDropDownMap(this.state.packing, "name");
    }

    private async getPacking() {
        const packingResponse = await PackingService.getAll();

        this.setState({
            packing: (packingResponse)?.data?.data || [],
            packingResponse
        });
    }
}

export default observer(CargoSection);